/**
 * Start Explore over: the header's logo and title, clicked while on Explore.
 *
 * A clean reload rather than resetting atoms one by one. Explore's state lives
 * in a dozen modules - ship, dates, columns, plot settings, filters, derived
 * signals, outliers, the export form - and `restoreFromUrl` only *applies* what
 * a query string names; it never puts back what is missing. A reset that listed
 * every atom would be wrong the day someone adds one. Loading `/` is exactly
 * what a new visitor gets, by construction.
 *
 * What survives is what is meant to: saved charts, views and dashboards (the
 * database and `localStorage`), the data source, and the sign-in. Feature
 * flags ride along too - they live only in the address bar (`?ff=`), and
 * starting over should not quietly end the preview someone was sent.
 */

import { activeFlags, type FeatureFlag } from './feature-flags.ts';
import { clearWorkingView } from './url-sync.ts';

/** The address of a fresh Explore, keeping any `?ff=` preview flags. */
export function freshUrl(flags: Iterable<FeatureFlag>, origin: string): string {
  const list = [...flags];
  return list.length ? `${origin}/?ff=${list.join(',')}` : `${origin}/`;
}

export function startOver(): void {
  clearWorkingView();
  window.location.assign(freshUrl(activeFlags, window.location.origin));
}
